import { render } from "./AddonSummaryModal.vue?vue&type=template&id=58ce97cb&ts=true"
import script from "./AddonSummaryModal.vue?vue&type=script&lang=ts"
export * from "./AddonSummaryModal.vue?vue&type=script&lang=ts"

import "./AddonSummaryModal.vue?vue&type=style&index=0&id=58ce97cb&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__